import { render, staticRenderFns } from "./MoveLoansModal.vue?vue&type=template&id=03f38dea"
import script from "./MoveLoansModal.vue?vue&type=script&lang=ts"
export * from "./MoveLoansModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03f38dea')) {
      api.createRecord('03f38dea', component.options)
    } else {
      api.reload('03f38dea', component.options)
    }
    module.hot.accept("./MoveLoansModal.vue?vue&type=template&id=03f38dea", function () {
      api.rerender('03f38dea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/MoveLoansModal.vue"
export default component.exports